import React from 'react';
import './yujiezju.css';
import {  Layout, Avatar } from 'antd';
import myAvatar from './images/myAvatar.jpg';
import { Link } from 'react-router-dom';

const { Header, Content, Footer } = Layout;

const Page1 = () => {
    return(
        <Layout className='layout'>
            <Header className='header'>
                <h1>流 霜</h1>
            </Header>
            <Layout>
                <Content className='content'>
                    <br/><br/><br/>
                    
                    <Avatar
                        size={{
                        xs: 120,
                        sm: 150,
                        md: 180,
                        lg: 220,
                        xl: 250,
                        xxl: 400,
                        }}
                        src={myAvatar}
                    />      
                    <div >
                    <h1>这是一些我写过的东西</h1>
                    <p>
                        <a href='http://yujiezju.run/Group13' className='href-blue' target='_blank'>
                        短学期课程《数据可视化》作业 - 第一次写前端</a>
                    </p>
                    <p>
                        <a href='http://yujiezju.run/MDedtr' className='href-green' target='_blank'>
                        简易的markdown编辑器 - 勉强能用</a>
                    </p>
                    <p>
                        <a href='https://fraserrr.github.io/xsxgroup01/' className='href-red' target='_blank'>
                        习概课程调研 - 思政课展示的奇思妙想</a>
                    </p>
                    <p>
                        <a href='http://yfers.yujiezju.run' className='href-purple' target='_blank'>
                        数据小站 - 参加了一个云峰的活动</a>
                    </p>
                    <p>
                        <a href='http://yujiezju.run/LMS' className='href-blue' target='_blank'>
                        图书管理系统 - 数据库课程作业</a>
                    </p>
                    <p style={{textAlign: 'center', paddingTop: '10px'}}><Link to="/" style={{color: "#F1AC7C"}}>返回主页</Link></p>
                    
                    </div>
                </Content>               
            </Layout>
            <Footer className='foot'>
            <a 
                href="https://beian.miit.gov.cn/" 
                target="_blank" 
                rel="noreferrer" 
                style={{color: 'gray'}}>
                滇ICP备2023016012号-2
            </a>
            </Footer>
        </Layout>
    );
}
export default Page1;